import { shouldAnimate } from '@helpers/animate';
import { fluid } from '@helpers/fluid';
import { paragraphSmall } from '@helpers/typography';
import styled, { css } from 'styled-components';
const Container = styled.span `
  ${paragraphSmall};

  position: relative;
  color: var(--fgColour);
  margin: 0;
  padding: ${fluid(8, 12)} 0 ${fluid(4, 6)};
  text-transform: uppercase;

  &::after {
    position: absolute;
    bottom: 0;
    left: 50%;
    display: block;
    content: '';
    width: 4px;
    height: ${fluid(30, 50)};
    background: transparent;
    background-image: linear-gradient(to bottom, transparent, var(--fgColour));
    background-repeat: no-repeat;
    background-size: 100% 100%;
    transform: translate(-50%, 100%);
    transform-origin: top center;

    ${shouldAnimate(css `
      animation: 1.5s linear infinite grow;
    `)}
  }

  @keyframes grow {
    0% {
      transform: translate(-50%, 100%) scaleY(0);
    }

    50% {
      transform: translate(-50%, 100%) scaleY(1);
    }
  }
`;
const ScrollIndictatorStyles = {
    Container,
};
export default ScrollIndictatorStyles;
